import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'pantallas',
    loadChildren: () =>
      import('./modules/pantallas/pantallas.module').then((m) => m.PantallasModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/app-shell/app-shell.module').then((m) => m.AppShellModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
